import {AxiosRequestConfig} from 'axios'
import RequestBase from '../../../api/RequestBase'

const URL = '/claims'

const getClaims = (config?: AxiosRequestConfig | undefined) => {
  return RequestBase.get(URL, config)
}

const getClaimDetail = (id?: any, config?: AxiosRequestConfig | undefined) => {
  return RequestBase.get(`${URL}/detail/${id}`, config)
}

const getClaimHistories = (id?: any, config?: AxiosRequestConfig | undefined) => {
  return RequestBase.get(`${URL}/histories/${id}?page_size=50`, config)
}

const exportClaims = (config?: AxiosRequestConfig | undefined) => {
  return RequestBase.get(`${URL}/export`, config)
}

const createClaims = (payload: any, config?: AxiosRequestConfig | undefined) => {
  return RequestBase.post(URL, payload, config)
}

const appealVerification = (payload: any, config?: AxiosRequestConfig | undefined) => {
  return RequestBase.post(`${URL}/appeal-verification`, payload, config)
}

const appeal = (payload: any, config?: AxiosRequestConfig | undefined) => {
  return RequestBase.post(`${URL}/appeal`, payload, config)
}

const uploadBatch = (payload: any, config?: AxiosRequestConfig | undefined) => {
  return RequestBase.post(`${URL}/upload`, payload, config)
}

const editClaims = (payload: any, config?: AxiosRequestConfig | undefined) => {
  return RequestBase.put(URL, payload, config)
}

const deleteClaims = (id, config?: AxiosRequestConfig | undefined) => {
  return RequestBase.remove(`${URL}/${id}`, config)
}
const checkTrackingNumber = (tracking_number, config?: AxiosRequestConfig | undefined) => {
  return RequestBase.post(`${URL}/store-verification`, {tracking_number}, config)
}

const ClaimService = {
  getClaims,
  getClaimDetail,
  getClaimHistories,
  exportClaims,
  createClaims,
  appealVerification,
  appeal,
  uploadBatch,
  editClaims,
  deleteClaims,
  checkTrackingNumber,
}

export default ClaimService
